import React from 'react';
import Loadable from 'react-loadable';

import SportsDefaultTitle from '@swf/components/SportsDefaultTitle/SportsDefaultTitle';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "SportsSeoWidget" */ './SportsSeoWidget'),
  modules: ['./SportsSeoWidget'],
  loading: () => <SportsDefaultTitle />
});

export default LoadableWidget;
